import {
  HexaContainer,
  HexaV2Button,
  HexaV2Dialog,
  HexaV2Text,
} from '@/components/hexa-v2'
import { useOpenOrClosePoc } from '@/proxy/seller/hooks/useOpenOrClosePoc'
import { STORE_AVAILABILITY as dict } from '@/resources/dict'
import ALL_POC_STATUSES from '@/resources/enums/pocStatus'
import { useEffect, useState } from 'react'
import * as S from './styles'
import { logger } from '@/monitoring/logger'
import { segmentClient } from '@/analytics/segmentClient'
import { pathNameToSegmentScreenName } from '@/resources/utils/analytics'
import { OwnerSquad } from '@/analytics/generated/segment'
import { useLocation } from 'react-router-dom'

type HexaV2StoreOpeningDialogProps = {
  handleSuccessfulOpening: () => void
  handleCloseModal: () => void
  show: boolean
}

const HexaV2StoreOpeningDialog = ({
  handleSuccessfulOpening,
  handleCloseModal,
  show,
}: HexaV2StoreOpeningDialogProps) => {
  const { pathname } = useLocation()
  const [storeOpeningErrors, setStoreOpeningErrors] = useState<string[]>([])
  const canSubmit = true
  const userErrors = storeOpeningErrors.filter(error => !!error)

  const openPoc = useOpenOrClosePoc()

  const openStore = () => {
    void openPoc.mutateAsync(
      {
        input: {
          operation: ALL_POC_STATUSES.AVAILABLE,
        },
      },
      {
        onSuccess: data => {
          if (data?.openOrClosePoc?.success) {
            logger.info('openStoreSuccess', {
              operation: ALL_POC_STATUSES.AVAILABLE,
              isTimeInsideWorking: data.openOrClosePoc.poc.isTimeInsideWorking,
            })
            setStoreOpeningErrors([])
            handleSuccessfulOpening()
          }

          if (data?.openOrClosePoc?.errors?.length) {
            logger.error('openStoreError', {
              errors: JSON.stringify(data?.openOrClosePoc?.errors),
              operation: ALL_POC_STATUSES.AVAILABLE,
            })
            setStoreOpeningErrors(data?.openOrClosePoc?.errors)
          }
        },
      }
    )
  }

  useEffect(() => {
    if (show) {
      segmentClient.storeClosingDialogModalViewed({
        screen_name: pathNameToSegmentScreenName(pathname),
        modal_name: 'store-closing-dialog',
        owner_squad: OwnerSquad.DtcZeOrders,
      })
    }
  }, [pathname, show])

  if (!show) return null

  return (
    <S.StoreOpeningDialogWrapper>
      <HexaV2Dialog
        type="custom"
        header={dict.openStore}
        className="store-closing-dialog"
        onHxClickClose={handleCloseModal}
      >
        <HexaContainer display="flex" styleOverrides={S.containerStyles}>
          {userErrors.length > 0 && (
            <S.ErrorContainer>
              {userErrors.map(error => (
                <HexaV2Text key={error} textStyle="bodySmall" text={error} />
              ))}
            </S.ErrorContainer>
          )}
          <HexaV2Text textStyle="bodyLarge" text={dict.openStoreModalTitleV2} />
          <HexaContainer display="flex" styleOverrides={S.buttonStyles}>
            <HexaV2Button variant="secondary" text={dict.cancel} size="small" />
            <HexaV2Button
              variant="primary"
              text={dict.openStore}
              size="small"
              disabled={!canSubmit}
              loading={openPoc.isPending}
              onClick={openStore}
            />
          </HexaContainer>
        </HexaContainer>
      </HexaV2Dialog>
    </S.StoreOpeningDialogWrapper>
  )
}

export default HexaV2StoreOpeningDialog
